'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Message = require('./Message');

var _Message2 = _interopRequireDefault(_Message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _Message2["default"];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/bee-message/build/index.js
// module id = 52
// module chunks = 0